import { DateComponentUnit } from '../../domain/DateComponentUnit'

export class DateComponentDTO {
    constructor(
        public unit: DateComponentUnit,
        public value: number
    ) {
    }
}
